/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout';

const systemManageRouter = {
  path: '/systemManage',
  component: Layout,
  redirect: '/systemManage/list',
  name: 'SystemManage',
  meta: {
    title: '系统管理',
    icon: 'el-icon-setting',
    roles: ['sysIndex', 'sysAdmin', 'sysRole', 'sysAuthority', 'sysLog'],
  },
  children: [
    // 用户列表
    {
      path: 'list',
      component: () => import('@/views/systemManage/user-manage/index.vue'),
      name: 'SystemUserList',
      meta: { title: '用户管理', icon: 'el-icon-user', roles: 'sysAdmin' },
    },
    {
      path: 'role',
      component: () => import('@/views/systemManage/role-manage/index.vue'),
      name: 'SystemRoleList',
      meta: { title: '角色管理', icon: 'el-icon-view', roles: 'sysRole' },
    },
    {
      path: 'auth',
      component: () => import('@/views/systemManage/auth-manage/index.vue'),
      name: 'SystemAuth',
      meta: { title: '权限管理', icon: 'el-icon-key', roles: 'sysAuthority' },
    },
    {
      path: 'basicOrganization',
      component: () => import('@/views/systemManage/basic-organization/index.vue'),
      name: 'PositionManage',
      meta: { title: '基层组织管理', icon: 'el-icon-bank-card', roles: 'org' },
    },
    {
      path: 'dictionaries',
      component: () => import('@/views/systemManage/dictionaries-manage/index.vue'),
      name: 'pointsConfig',
      meta: { title: '字典配置', icon: 'el-icon-coin', roles: 'dict' },
    },
    {
      path: 'logs',
      component: () => import('@/views/systemManage/log-manage/index.vue'),
      name: 'SystemLogs',
      meta: { title: '日志管理', icon: 'el-icon-s-operation', roles: 'sysLog' },
    },
  ],
};
export default systemManageRouter;
